export default __webpack_public_path__ + "static/4-b03aee9567d9f8381af217453e7c9fb8.png";